<template>
  <div class="">
    <div class="panel-heading">
      <span>Lectures</span>
      <div class="panel-heading-buttons">
        <b-button
          v-if="canEdit && curriculum"
          label="Reorder"
          type="is-info"
          size="is-small"
          icon-left="sort-amount-up"
          @click="$emit('reorder')"
        />

        <b-button
          v-if="canEdit && curriculum"
          label="Save"
          type="is-warning"
          size="is-small"
          icon-left="save"
          @click="$emit('save')"
        />
      </div>
    </div>

    <div class="column-container">
      <div class="items-list" v-if="curriculum">
        <ModulePlaceholder
          v-for="(module, index) in curriculum.modules || []"
          :key="index"
          :index="index"
          title="Lecture"
          :maxItems="3"
          :topics="module.topicIds.map(lessonObj)"
          :canEdit="false"
          :canRemove="canEdit"
          @drop="canEdit && $emit('drop', $event)"
          @full="$emit('full', $event)"
          @edit="canEdit && $emit('edit', $event)"
          @clear="canEdit && $emit('clear', $event)"
          @select-topic="$emit('select-topic', $event)"
          @remove-topic="canEdit && $emit('remove-topic', $event)"
        />

        <b-button
          v-if="canEdit"
          label="`Add Lecture"
          class="add-module-button mt-4"
          type="is-primary is-light"
          icon-left="plus"
          @click="addModule"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ModulePlaceholder from "./ModulePlaceholder.vue";

export default {
  name: "ModulesColumn",

  components: { ModulePlaceholder },

  props: {
    curriculum: { type: Object, default: null },
    getTopicById: { type: Function, required: true },
    canEdit: { type: Boolean, default: false },
  },

  watch: {
    curriculum: {
      immediate: true,
      handler(newCurriculum) {
        if (!newCurriculum) return;
        const existingModules = this.curriculum.modules || [];
        const emptyModules = !existingModules.length
          ? Array(12 - existingModules.length)
              .fill()
              .map(() => ({ topicIds: [] }))
          : [];
        newCurriculum.modules = [...existingModules, ...emptyModules];
      },
    },
  },

  methods: {
    lessonObj(topicId) {
      return {
        ...this.getTopicById(topicId),
        isOptional: this.curriculum?.lessons?.find(
          (lesson) => lesson.topicId === topicId
        )?.isOptional,
        usage: " ",
      };
    },

    addModule() {
      this.curriculum.modules.push({ topicIds: [] });
      this.$nextTick(() => {
        const container = this.$el.querySelector(".column-container");
        container.scrollTop = container.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
.panel-heading {
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-bottom: 2px solid #dbdbdb;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.panel-heading-buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.column-container {
  height: calc(100% - 52px); /* Adjusted to account for the panel heading */
  overflow-y: auto;
}

.items-list {
  width: 100%;
}
</style>
